/* ethetic v8 home page: hero fade, tabs, row arrows, centred room card */
(function () {
  function initHero(hero) {
    if (hero.dataset.ready) return; hero.dataset.ready = '1';
    var slides = [].slice.call(hero.querySelectorAll('.eh-slide'));
    var dots = [].slice.call(hero.querySelectorAll('.eh-dot'));
    var i = 0, timer;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function play() {
      clearInterval(timer);
      if (slides.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = setInterval(function () { show(i + 1); }, 6000);
    }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); play(); }); });
    /* Swipe on phones, drag with a mouse. Slides are links, so a swipe must not open one */
    if (slides.length > 1) {
      var startX = null, startY = 0, swiped = false;
      function begin(x, y) { startX = x; startY = y; swiped = false; clearInterval(timer); }
      function end(x, y) {
        if (startX === null) return;
        var dx = x - startX, dy = y - startY;
        startX = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { swiped = true; show(i + (dx < 0 ? 1 : -1)); }
        play();
      }
      hero.addEventListener('touchstart', function (e) { begin(e.touches[0].clientX, e.touches[0].clientY); }, { passive: true });
      hero.addEventListener('touchend', function (e) { end(e.changedTouches[0].clientX, e.changedTouches[0].clientY); }, { passive: true });
      hero.addEventListener('touchcancel', function () { startX = null; play(); }, { passive: true });
      hero.addEventListener('mousedown', function (e) { if (e.button === 0 && !e.target.closest('.eh-dot')) begin(e.clientX, e.clientY); });
      hero.addEventListener('mouseup', function (e) { end(e.clientX, e.clientY); });
      hero.addEventListener('mouseleave', function (e) { end(e.clientX, e.clientY); });
      hero.addEventListener('dragstart', function (e) { e.preventDefault(); });
      hero.addEventListener('click', function (e) {
        if (swiped) { e.preventDefault(); e.stopPropagation(); swiped = false; }
      }, true);
    }
    show(0); play();
  }

  function initRow(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var prev = root.querySelector('[data-eh-prev]'), next = root.querySelector('[data-eh-next]');
    function track() {
      var all = root.querySelectorAll('.eh-track');
      for (var k = 0; k < all.length; k++) if (all[k].offsetParent !== null) return all[k];
      return all[0];
    }
    function sync() {
      var t = track(); if (!t || !prev || !next) return;
      prev.disabled = t.scrollLeft <= 2;
      next.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 2;
    }
    function move(dir) {
      var t = track(); if (!t) return;
      var item = t.firstElementChild, gap = parseFloat(getComputedStyle(t).columnGap) || 0;
      t.scrollBy({ left: dir * (item.getBoundingClientRect().width + gap) * Math.max(1, Math.floor(t.clientWidth / item.getBoundingClientRect().width) - 1), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });
    [].forEach.call(root.querySelectorAll('.eh-track'), function (t) { t.addEventListener('scroll', sync, { passive: true }); });
    var tabs = [].slice.call(root.querySelectorAll('.eh-tab'));
    var panels = [].slice.call(root.querySelectorAll('.eh-panel'));
    var foot = root.querySelector('[data-eh-all]');
    tabs.forEach(function (tab, k) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (x, j) { x.classList.toggle('is-active', j === k); x.setAttribute('aria-selected', j === k ? 'true' : 'false'); });
        panels.forEach(function (p, j) { p.hidden = j !== k; });
        if (foot) { foot.href = tab.dataset.url; foot.firstChild.textContent = tab.dataset.all + ' '; }
        var t = track(); if (t) t.scrollLeft = 0;
        sync();
      });
    });
    sync();
    addEventListener('resize', sync);
  }

  function initRooms(track) {
    if (track.dataset.ready) return; track.dataset.ready = '1';
    var cards = [].slice.call(track.children), raf;
    function mark() {
      var box = track.getBoundingClientRect(), mid = box.left + box.width / 2, best = null, min = 1e9;
      cards.forEach(function (c) {
        var r = c.getBoundingClientRect(), d = Math.abs(r.left + r.width / 2 - mid);
        if (d < min) { min = d; best = c; }
      });
      cards.forEach(function (c) { c.classList.toggle('is-center', c === best); });
    }
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(mark); }, { passive: true });
    var start = cards[Math.floor(cards.length / 2)];
    if (start) track.scrollLeft = start.offsetLeft - (track.clientWidth - start.offsetWidth) / 2;
    mark();
  }

  // Room videos: silent, and only play while on screen so a phone isn't downloading all of them at once
  function initVideos() {
    var calm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var saver = navigator.connection && navigator.connection.saveData;
    if (calm || saver || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { var p = e.target.play(); if (p && p.catch) p.catch(function () {}); }
        else e.target.pause();
      });
    }, { threshold: 0.4 });
    [].forEach.call(document.querySelectorAll('[data-eh-video]:not([data-ready])'), function (v) { v.setAttribute('data-ready', '1'); v.muted = true; io.observe(v); });
  }

  function init() {
    [].forEach.call(document.querySelectorAll('.eh-hero'), initHero);
    [].forEach.call(document.querySelectorAll('[data-eh-row]'), initRow);
    [].forEach.call(document.querySelectorAll('.eh-rooms__track'), initRooms);
    initVideos();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
